 import React from 'react'
 import { useSlate } from 'slate-react'
 import { Editor } from 'slate'
 import {Button,Icon} from './ToolbarButton'


const MarkButton = ({ format, icon }) => {
    const toggleMark = (editor, format) => {
        const isActive = isMarkActive(editor, format)
      
        if (isActive) {
          Editor.removeMark(editor, format)
        } else {
          Editor.addMark(editor, format, true)
        }
      }
    const isMarkActive = (editor, format) => {
        const marks = Editor.marks(editor)
        return marks ? marks[format] === true : false
    }
    const editor = useSlate()
    return (
      <Button
        className="mx-1"
        active={isMarkActive(editor, format)}
        onMouseDown={event => {
          event.preventDefault()
          toggleMark(editor, format)
        }}
      >
        <Icon>{icon}</Icon>
      </Button>
    )
}

export default MarkButton